import React from 'react';
import { Typography } from '@strapi/design-system/Typography';
import { ModalHeader } from '@strapi/design-system/ModalLayout';
import { useIntl } from 'react-intl';
import { WIDEN_MODAL_ASSET_TITLE_ID, WIDEN_MODAL_TITLE } from '../../utils/constants';
export const DialogTitle = () => {
  return /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Typography, {
    fontWeight: "bold",
    textColor: "neutral800",
    as: "h2",
    id: WIDEN_MODAL_ASSET_TITLE_ID
  }, WIDEN_MODAL_TITLE));
};